// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem("DoxAndBoxToken");
//   return isAuthenticated ? children : <Navigate to="/login" />;
// };

// export default ProtectedRoute;


import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem("DoxAndBoxToken");

  useEffect(() => {
    let interval;

    const verifyUser = async () => {
      try {
        await axios.get(`${BaseUrl}api/rbac/my-permissions`, {
          headers: {
            "x-access-token": token,
          },
        });

        setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("DoxAndBoxToken");
          localStorage.removeItem("username");
          localStorage.removeItem("email");
          setIsValid(false);
          return;
        }

        setIsValid(true);
      }
    };

    if (token) {
      // 👉 First time check
      verifyUser();

      // Re-check every 10 minutes so password changes log active users out automatically.
      interval = setInterval(() => {
        verifyUser();
      }, 600000);
    } else {
      setIsValid(false);
    }

    // 👉 Cleanup (VERY IMPORTANT)
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [token]);

  // ⏳ While checking
  if (isValid === null) {
    return <div>Loading...</div>;
  }

  // ❌ Not valid → redirect
  if (!isValid) {
    return <Navigate to="/login" />;
  }

  // ✅ Valid
  return children;
};

export default ProtectedRoute;
